import { useRecoilValue } from 'recoil';

import { selectedShipmentInfoState, selectedShipmentPicturesState } from '../../states/shipment';
import { BlueBox, RedBox } from '../../components/Box';
import { Box, Grid, Typography } from '@mui/material';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import { H4 } from '../../components/Heading';
import CodeBloc from '../../components/CodeBloc';
import ShipmentPODContainer from '../ShipmentPODContainer';
import { tokens } from '@gojitsu/web-ui-core';

export default function OutboundInfoContainer() {
  const info = useRecoilValue(selectedShipmentInfoState);
  const { assignment, pickup, dropoff, driver, has_customer_positive_feedback } = info || {};
  const pictures = useRecoilValue(selectedShipmentPicturesState);

  if (!assignment) return <></>;
  return (
    <BlueBox>
      {has_customer_positive_feedback === false && (
        <div style={{ paddingTop: 10 }}>
          <span style={{ display: 'inline-flex', alignItems: 'center' }} className="legend-label">
            <ThumbDownIcon color='error' />
            <Box component="span" sx={{ margin: '5px', color: tokens.red.red45, fontSize: '1.2em' }}>The customer has left a negative feedback</Box>
          </span>
        </div>
      )}

      {has_customer_positive_feedback === true && (
        <div style={{ paddingTop: 10 }}>
          <span style={{ display: 'inline-flex', alignItems: 'center' }} className="legend-label">
            <ThumbUpIcon color='primary' />
            <Box component="span" sx={{ margin: '5px', color: 'blue', fontSize: '1.2em' }}>The customer has left a positive feedback</Box>
          </span>
        </div>
      )}

      <Grid container>
        <Grid size={{ xs: 12, md: 5 }}>
          <H4>Assignment</H4>
          <Typography>
            <CodeBloc style={{ fontSize: 12 }}>[{assignment.id}]</CodeBloc> {assignment.label}
          </Typography>
          {driver && (
            <>
              <H4>Driver</H4>
              <Typography>
                <CodeBloc style={{ fontSize: 12 }}>[{driver.id}]</CodeBloc> {driver.first_name} {driver.last_name}
              </Typography>
              <Typography>
                <CodeBloc>{driver.phone_number}</CodeBloc>
              </Typography>
            </>
          )}
        </Grid>
        <Grid size={{ xs: 12, md: 7 }}>
          {dropoff && (
            <>
              <H4>Dropoff</H4>
              <Grid container>
                <Grid size={6}>
                  <CodeBloc>{dropoff.status}</CodeBloc>
                </Grid>
                <Grid size={6}>
                  <CodeBloc>{dropoff.reason}</CodeBloc>
                </Grid>
                <Grid size={12}>
                  <Typography style={{ color: '#666' }}>{dropoff.remark}</Typography>
                </Grid>
              </Grid>
            </>
          )}
          {!dropoff && (
            <RedBox>
              WARNING: Dropoff stop not found
              {pickup && (
                <>
                  {' '}
                  <H4>Pickup</H4>
                  <div>
                    <CodeBloc>{pickup.status}</CodeBloc>
                  </div>
                </>
              )}
            </RedBox>
          )}
          <ShipmentPODContainer pictures={pictures} />
        </Grid>
      </Grid>
    </BlueBox>
  );
}
